import { render, staticRenderFns } from "./FormMultiFileUploaderVideoModule.vue?vue&type=template&id=3d09c4ab&"
import script from "./FormMultiFileUploaderVideoModule.vue?vue&type=script&lang=ts&"
export * from "./FormMultiFileUploaderVideoModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports